package com.playoffpulse.frontend.ui

import com.playoffpulse.shared.model.MagicStatus
import com.playoffpulse.shared.model.MagicSummary

fun gamesRemaining(summary: MagicSummary): Int {
    return ((summary.maxPossiblePoints - summary.currentPoints) / 2).coerceAtLeast(0)
}

fun mustWinCount(
    summary: MagicSummary,
    gamesRemaining: Int = gamesRemaining(summary),
): Int {
    val requiredWins = (summary.magicPointsToClinch + 1) / 2
    return requiredWins.coerceIn(0, gamesRemaining)
}

fun gamesRemainingSubtext(
    summary: MagicSummary,
    gamesRemaining: Int = gamesRemaining(summary),
): String {
    return when (summary.status) {
        MagicStatus.CHASING -> "Needs wins plus help to stay alive."
        MagicStatus.CLINCHED ->
            if (summary.nextClinchTargetSeatCode != null) {
                "Still climbing toward ${summary.nextClinchTargetSeatCode}."
            } else {
                "Clinch path complete."
            }
        MagicStatus.ELIMINATED -> "No clinch path remains."
        else -> "Must win ${mustWinCount(summary, gamesRemaining)} of $gamesRemaining"
    }
}

fun pathTableText(
    summary: MagicSummary,
    gamesRemaining: Int = gamesRemaining(summary),
): String {
    return when (summary.status) {
        MagicStatus.CHASING -> "Wins + help"
        MagicStatus.CLINCHED -> if (summary.nextClinchTargetSeatCode != null) "Next seat" else "Clinched"
        MagicStatus.ELIMINATED -> "Out"
        else -> "Win ${mustWinCount(summary, gamesRemaining)}/$gamesRemaining"
    }
}
